module.exports = __webpack_public_path__ + "static/contact-BAM.b01c33f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact-BAM.png
// module id = 1471
// module chunks = 43369700788870